import {
  USERS_ENDPOINT,
  USER_BY_ID_ENDPOINT,
  USERS_DROPDOWN_ENDPOINT,
} from "./endpoints";
import { getAPI, postAPI, putAPI, deleteAPI } from "./apiMethods";

export async function getUsers() {
  return getAPI(USERS_ENDPOINT);
}

export async function createUser(userData) {
  return postAPI(USERS_ENDPOINT, userData);
}

export async function updateUser(id, userData) {
  return putAPI(USER_BY_ID_ENDPOINT(id), userData);
}

export async function deleteUser(id) {
  return deleteAPI(USER_BY_ID_ENDPOINT(id));
}

export async function getUserById(id) {
  return getAPI(USER_BY_ID_ENDPOINT(id));
}

export async function getUsersDropdown() {
  return getAPI(USERS_DROPDOWN_ENDPOINT);
}
